/* External dependencies */
import React from 'react';

/* Local dependencies */
import Button, { CustomButtonProps } from './Button';

export default function PrimaryButton(props: CustomButtonProps) {
  return (
    <Button {...props} type={props?.type || 'primary'}>
      {props.children}
    </Button>
  );
}
